import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, Chip, Typography } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, TextField, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { NGO } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import EditPenIcon from "src/svgComponents/EditPenIcon";
import BinIcon from "src/svgComponents/BinIcon";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ShowImage from "../common/ShowImage";
import useStore from 'src/contexts/AuthProvider'
import AppTooltip from "src/components/common/AppTooltip";
import moment from "moment";
import { LoadingButton } from '@mui/lab';
const _ = require('lodash');

const Ngo = () => {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('createdAt');
    const axiosPrivate = useAxiosPrivate();
    const [openModal, setOpenModal] = useState(false);
    const [profilePic, setProfilePic] = useState("");
    const [imageName, setImageName] = useState();
    const [showImage, setShowImage] = useState();
    const [modelTitle, setmodelTitle] = useState("");
    const [filterName, setFilterName] = useState('');
    const permissionsData = useStore(state => state.permissions);
    const [disable, setDisable] = useState(false);
    const [Id, setId] = useState("");
    const { enqueueSnackbar } = useSnackbar();
    const [deleteId, setdeleteId] = useState("");
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const [loading, setLoding] = useState(true);
    const [uploadedImage, setUploadedImage] = useState();
    const [flag, setFlag] = useState();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [buttonLoading, setButtonLoding] = useState(false);

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    const TABLE_HEAD = [
        { id: 'title', label: 'Title', alignRight: false },
        { id: 'sub_title', label: 'Sub Title', alignRight: false },
        { id: 'image', label: 'Image', alignRight: false },
        { id: 'description', label: 'Description', alignRight: false },
        { id: 'about', label: 'About', alignRight: false },
        { id: 'fund', label: 'Fund', alignRight: false },
        { id: 'percentage', label: 'Percentage', alignRight: false },
        { id: 'total_amount', label: 'Total Amount', alignRight: false },
        { id: 'created', label: 'Dated On', alignRight: false },
        { id: 'status', label: 'Status', alignRight: false },
        { id: 'action', label: 'Action', alignRight: false },
    ];

    async function getNgo(page, filterName) {
        const response = await axiosPrivate.get(NGO.getNgo, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
        return response.data[0];
    }

    const { data: ngoList, refetch } = useQuery(['ngoList', page, filterName], () => getNgo(page, filterName), { keepPreviousData: true, })

    useEffect(() => {
        if (ngoList) {
            setTableData(ngoList.data);
            setRowsPerPage(ngoList?.metadata.length != 0 ? ngoList?.metadata[0].limit : 10);
        }
        if (ngoList?.metadata.length != 0 && ngoList?.metadata[0].hasMoreData == true) {
            getNgo(page + 1);
        }
        setTimeout(() => {
            setLoding(false);
        }, 1000)
    }, [ngoList])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTimeout(() => {
            refetch();
        }, 500);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleFilterByName = (event) => {
        setFilterName(event.target.value.trim());
        setPage(0);
        getNgo(page, filterName)
        refetch();
    };

    const handleUploadImage = async () => {
        const formData = new FormData();
        formData.append('image', uploadedImage)
        const imageData = await axiosPrivate
            .post(NGO.uploadImage, formData)
            .catch((e) => {
                setButtonLoding(false);
                enqueueSnackbar(e?.response?.data?.message, {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
            });
        if (imageData) {
            setButtonLoding(true);
        }
        setImageName(imageData?.data?.file_name)
        setFieldValue("image", imageData?.data?.file_name)
        return imageData?.data?.file_name;
    }

    const completedSchema = Yup.object().shape({
        title: Yup.string()
            .min(2, "Title can set of between 2 and 50 characters!")
            .max(50, "Title can set of between 2 and 50 characters!")
            .required("Title is required"),
        sub_title: Yup.string().required('Sub Title is required'),
        total_amount: Yup.string().required('Total Amount is required'),
        description: Yup.string().required('Description is required'),
        about: Yup.string().required('About is required'),
    });

    const formik = useFormik({
        initialValues: {
            title: "",
            description: "",
            about: "",
            sub_title: "",
            total_amount: "",
            image: ""
        },
        validationSchema: completedSchema,
        onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
            let image_name = '';
            if (!imageName) {
                if (flag === 'asd') {
                    image_name = await handleUploadImage();
                }
            } else {
                image_name = imageName
            }
            const informationObj = {
                title: values.title,
                sub_title: values.sub_title,
                fund: values.fund,
                description: values.description,
                about: values.about,
                total_amount: values.total_amount,
                percentage: values.percentage,
                image: image_name
            };
            if (Id == "") {
                await ngoAdd(informationObj);
            } else {
                await ngoUpdate(informationObj);
            }
            resetForm();
            setSubmitting(false);
        },
    });

    const { mutateAsync: ngoAdd } = useMutation(
        async (data) => {
            return await axiosPrivate.post(NGO.ngoAdd, data)
        },
        {
            onSuccess: ({ data }) => {
                enqueueSnackbar(data.message, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
                handleCloseModal();
                refetch();
                setButtonLoding(false);
            },
            onError: (error) => {
                setButtonLoding(false);
                const errorData = error.response.data.errors;
                if (error.response?.data?.message) {
                    enqueueSnackbar(error.response?.data?.message, {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                }
                Object.keys(errorData).forEach((key) => {
                    if (key === "title") {
                        setFieldError("title", errorData[key]);
                    }
                    else if (key === "sub_title") {
                        setFieldError(key, errorData[key]);
                    }
                    else if (key === "description") {
                        setFieldError(key, errorData[key]);
                    }
                    else if (key === "image") {
                        setFieldError(key, errorData[key]);
                    }
                    else if (key === "total_amount") {
                        setFieldError(key, errorData[key]);
                    }
                    else {
                        setFieldError(key, errorData[key]);
                    }
                });
            },
        }
    );

    const { mutateAsync: ngoUpdate } = useMutation(
        async (data) => {
            return await axiosPrivate.patch(NGO.ngoUpdate + "/" + Id, data)
        },
        {
            onSuccess: ({ data }) => {
                refetch();
                enqueueSnackbar(data.message, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
                handleCloseModal();
                setButtonLoding(false);
            },
            onError: (error) => {
                setButtonLoding(false);
                const errorData = error.response.data.errors;
                if (error.response?.data?.message) {
                    enqueueSnackbar(error.response?.data?.message, {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                }
                Object.keys(errorData).forEach((key) => {
                    if (key === "title") {
                        setFieldError("title", errorData[key]);
                    } else if (key === "food_category_id") {
                        setFieldError(key, errorData[key]);
                    }
                    else if (key === "sub_title") {
                        setFieldError(key, errorData[key]);
                    }
                    else if (key === "description") {
                        setFieldError(key, errorData[key]);
                    }
                    else if (key === "image") {
                        setFieldError(key, errorData[key]);
                    }
                    else if (key === "total_amount") {
                        setFieldError(key, errorData[key]);
                    }
                    else {
                        setFieldError(key, errorData[key]);
                    }
                });
            },
        }
    );

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function applySortFilter(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });

        return stabilizedThis.map((el) => el[0]);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categoryList?.metadata[0].total) : 0;

    const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

    const handleClose = () => {
        setOpen(false);
        setShowImage('');
    };

    const deleteNgo = async () => {
        const response = await axiosPrivate.delete(NGO.deleteNgo + '/' + deleteId)
        if (response.status == 200) {
            enqueueSnackbar(response.data.message, {
                variant: "success",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        } else {
            enqueueSnackbar("Something went wrong", {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
        refetch();
        handleClose();
    };

    const handleOpenModalAdd = () => {
        setFieldValue('title', "")
        setFieldValue('description', "")
        setFieldValue('about', "")
        setFieldValue('sub_title', "")
        setFieldValue('total_amount', "")
        setFieldValue('image', "")

        setFieldError("image", "")
        setFieldTouched("image", "")

        setShowImage('');
        setProfilePic('');
        setImageName('');
        setId('')
        setmodelTitle('Ngo Add')
        setDisable(false);
        setOpenModal(true);
    };

    const handleOpenModalUpdate = (row) => {
        setFieldValue("title", row.title)
        setFieldValue("description", row.description)
        setFieldValue("about", row.about)
        setFieldValue('sub_title', row.sub_title)
        setFieldValue('total_amount', row.total_amount)
        setImageName(row.image)
        setShowImage(row.image)
        setId(row._id)
        setmodelTitle('Ngo Update')

        setFieldError("image", "")
        setFieldTouched("image", "")

        setFieldError("title", "")
        setFieldTouched("title", "")

        setFieldError("sub_title", "")
        setFieldTouched("sub_title", "")

        setFieldError("total_amount", "")
        setFieldTouched("total_amount", "")

        setFieldError("description", "")
        setFieldTouched("description", "")

        setFieldError("about", "")
        setFieldTouched("about", "")

        setDisable(true);
        setOpenModal(true);
    };

    const handleClickOpen = (categoryId, categoryType) => {
        setdeleteId(categoryId);
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        resetForm();
    };

    const handleProfilePicOnChange = async (ev) => {
        if (ev.type.includes("image")) {
            setUploadedImage(ev);
            let userImgSrc = URL.createObjectURL(ev);
            setProfilePic(userImgSrc);
            setImageName('')
        } else {
            enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
    };

    const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched, resetForm } = formik;

    const removeImage = () => {
        setProfilePic('');
        setImageName('');
        setShowImage('');
    }
    const changeStatus = async (id) => {
        const response = await axiosPrivate.put(NGO.changeStatus + '/' + id)
        if (response?.data?.message) {
            enqueueSnackbar(response?.data?.message, {
                variant: "success",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
        refetch()
    }

    return (
        <>
            <LoadingScreen loading={loading} />
            {/* <div className="dashboard_header mb-4">
                    <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Ngo</h4>
                    <Box className="d-flex align-items-center">
                        <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                            <IconButton>
                                <SearchIcon />
                            </IconButton>
                            <InputBase
                                fullWidth
                                sx={{ flex: 1 }}
                                placeholder="Search Ngo..."
                                onChange={(e) => handleFilterByName(e)}
                            />
                        </Paper>
                    </Box>
                    <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                        <Button className="dashboard_light_bg_icon_btn" onClick={handleOpenModalAdd} ><AddCircleOutlineOutlinedIcon style={{ fontSize: 18, color: "#fff" }} /></Button>
                    </Stack>
                </div> */}
            <div className="dashboard_header mb-4">
                <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Ngo</h4>
                <Box className="d-flex align-items-center">
                    <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            fullWidth
                            sx={{ flex: 1 }}
                            placeholder="search ngo..."
                            onChange={(e) => handleFilterByName(e)}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                    </Paper>
                    <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                        {permissionsData?.ngo?.substring(1, 2) == "1" ?
                            <AppTooltip title="Add Charity Event" placement="bottom">
                                <Button className="dashboard_light_bg_icon_btn" onClick={handleOpenModalAdd} ><AddCircleOutlineOutlinedIcon style={{ fontSize: 18, color: "#fff" }} /></Button>
                            </AppTooltip> : ""}
                    </Stack>
                </Box>
            </div>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" className='m-auto'>
                    {"Are you sure you want to delete?"}
                </DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions className='m-auto'>
                    <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className="theme_button" variant="contained" onClick={() => deleteNgo()} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <Card>
                <TableContainer>
                    <Table>
                        <UserListHead
                            headLabel={TABLE_HEAD}
                            rowCount={ngoList?.data?.length}
                            onRequestSort={handleRequestSort}
                        />
                        {filteredUsers?.length > 0 ?
                            <TableBody>
                                {filteredUsers.map((row) => {
                                    return (
                                        <StyledTableRow key={row._id}>
                                            <TableCell component="th" scope="row">
                                                {row.title.substring(0, 30) + (row?.title.length >= 30 ? ' ....' : '')}
                                            </TableCell>
                                            <TableCell align="left"> {row.sub_title.substring(0, 30) + (row?.sub_title.length >= 30 ? ' ....' : '')}</TableCell>
                                            <TableCell component="th" scope="row">
                                                <img src={process.env.REACT_APP_PROFILE_URL + 'ngoItems/' + row.image} height="50px" alt="profile" />
                                            </TableCell>
                                            <TableCell align="left" style={{ width: '340px', wordBreak: 'break-word' }} component="th"> {row?.description?.substring(0, 33) + (row?.description?.length >= 33 ? ' ....' : '')}</TableCell>
                                            <TableCell align="left" style={{ width: '340px', wordBreak: 'break-word' }} component="th"> {row?.about?.substring(0, 33) + (row?.about?.length >= 33 ? ' ....' : '')}</TableCell>
                                            <TableCell align="left"> £{row.fund?.toFixed(2) ?? '0.00'}</TableCell>
                                            <TableCell align="left"> {row.percentage} %</TableCell>
                                            <TableCell align="left"> £{row.total_amount?.toFixed(2) ?? '0.00'}</TableCell>
                                            <TableCell align="left" style={{ width: '300px' }}><span className="d-flex text-nowrap">{moment(row.createdAt).format("DD MMM YYYY h:mm A")}</span></TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={3}>
                                                    {
                                                        row.status == 1 ? <Chip variant="contained" label="Enable" className="app_status_chip accepted" onClick={() => changeStatus(row._id)} /> : <Chip variant="contained" className="app_status_chip invalid" label="Disable" onClick={() => changeStatus(row._id)} />
                                                    }
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={3}>
                                                    {permissionsData?.ngo?.substring(3, 4) == "1" ?
                                                        <AppTooltip title="Edit" placement="bottom">
                                                            <Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleOpenModalUpdate(row)} variant="text" className="user_list_row_btn"><EditPenIcon /></Button>
                                                        </AppTooltip> : ""}
                                                    {permissionsData?.ngo?.substring(2, 3) == "1" ?
                                                        <AppTooltip title="Delete" placement="bottom">
                                                            <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                                        </AppTooltip> : ""}
                                                </Stack>
                                            </TableCell>
                                        </StyledTableRow>
                                    )
                                })}
                                {/* {emptyRows > 0 && (
<TableRow style={{ height: 53 * emptyRows }}>
<TableCell colSpan={6} />
</TableRow>
)} */}
                            </TableBody>
                            :
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={11} sx={{ py: 5 }}>
                                        <span className="app_text_16_semibold">No Data Found</span>
                                    </TableCell>
                                </TableRow>
                            </TableBody>}

                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    count={ngoList?.metadata.length != 0 ? ngoList?.metadata[0].total : 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                size='md'
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h4>{modelTitle}</h4>
                        <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                            <CloseIcon style={{ color: '#fff' }} />
                        </Button>
                    </Box>
                </DialogTitle>
                <DialogContent className="custom_form_mui pt-2">
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <TextField label='Title' name='title' autoComplete='off' fullWidth variant='outlined'
                                            {...getFieldProps("title")}
                                        />
                                        {errors.title && touched.title && <Typography color="error">{errors.title}</Typography>}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group mb-3">
                                        <TextField label='Sub Title' name='sub_title' autoComplete='off' fullWidth variant='outlined'
                                            {...getFieldProps("sub_title")}
                                        />
                                        {errors.sub_title && touched.sub_title && <Typography color="error">{errors.sub_title}</Typography>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="col">
                                        <div className="form-group mb-4">
                                            <TextField sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '3.5rem' } }} label='Description' multiline name='description' autoComplete='off' fullWidth
                                                {...getFieldProps("description")}
                                            />
                                            {errors.description && touched.description && <Typography color="error">{errors.description}</Typography>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="col">
                                        <div className="form-group mb-4">
                                            <TextField sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '3.5rem' } }} label='About' multiline name='about' autoComplete='off' fullWidth
                                                {...getFieldProps("about")}
                                            />
                                            {errors.about && touched.about && <Typography color="error">{errors.about}</Typography>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group mb-4">
                                        <TextField label='Total Amount' name='total_amount' type='number' autoComplete='off' fullWidth variant='outlined'
                                            {...getFieldProps("total_amount")}
                                        />
                                        {errors.total_amount && touched.total_amount && <Typography color="error">{errors.total_amount}</Typography>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <ShowImage modalId={Id} profilePic={profilePic} showImage={showImage} folderName="ngoItems/" onRemoveFunc={() => { removeImage() }} />
                                <Button
                                    className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                                    variant="contained"
                                    component="label"
                                    style={{ "borderRadius": 5 }}
                                >
                                    {Id ? 'Change image' : 'Select Image'}
                                    <input
                                        hidden
                                        accept="image/*"
                                        onChange={(event) => {
                                            const files = event.target.files[0];
                                            if (files !== undefined) {
                                                setFlag('asd')
                                                handleProfilePicOnChange(files);
                                            }
                                        }}
                                        type="file"
                                    />
                                </Button>
                                {errors.image && touched.image && <Typography color="error">{errors.image}</Typography>}
                            </div>
                            <div className="col">
                                <div className="col-md-8 m-auto">
                                    <LoadingButton
                                        type='submit'
                                        fullWidth
                                        className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                                        loading={buttonLoading}
                                        loadingPosition="end"
                                        variant="contained"
                                    >
                                        submit
                                    </LoadingButton>
                                </div>
                            </div>
                        </Form>
                    </FormikProvider>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default Ngo
